import { Trans } from '@lingui/react';
import { i18n } from '@lingui/core';
import React from 'react';
import { useBreakpoint, useNavBarContext as useNavBarContext$1, DropdownMenu, List, SearchOutlined, IconButton, callAllHandlers } from '@landr/maestro';
import '../../../../../../utils/analytics/index.es.js';
import { useLinkClickHandler } from '../../../../hooks/useLinkClickHandler.es.js';
import { useLinkAnalyticsV2Handler } from '../../../../hooks/useLinkAnalyticsV2Handler.es.js';
import { CtaGoal } from '../../../../../../utils/analytics/PlatformAnalyticsV2Service.generated.es.js';
import { openNetworkLink, openSamplesLink, openEducationLink } from '../../../../../../utils/links.es.js';
import { useNavBarContext } from '../../../../../../contexts/NavBarProvider/NavBarContext.es.js';
import { getNetworkLink, getSamplesLink, getEducationLink } from '@landr/core';

var NavBarSearch = function NavBarSearch() {
  var isMobile = useBreakpoint('md');
  var _useNavBarContext = useNavBarContext(),
    env = _useNavBarContext.env;
  var _useMaestroNavBarCont = useNavBarContext$1(),
    closePanel = _useMaestroNavBarCont.closePanel;
  var handleLinkClick = useLinkClickHandler(closePanel);
  var handleSendAnalyticsV2 = useLinkAnalyticsV2Handler();
  var handleMenuOpened = handleSendAnalyticsV2(CtaGoal.SearchNetwork, 'Search');
  return /*#__PURE__*/React.createElement(DropdownMenu, {
    placement: "bottom-end",
    offset: [0, 8],
    onOpen: handleMenuOpened
  }, /*#__PURE__*/React.createElement(DropdownMenu.Trigger, null, isMobile ? /*#__PURE__*/React.createElement(List.Item, null, /*#__PURE__*/React.createElement(List.ItemIcon, null, /*#__PURE__*/React.createElement(SearchOutlined, null)), /*#__PURE__*/React.createElement(Trans, {
    id: "A1taO8"
  })) : /*#__PURE__*/React.createElement(IconButton, {
    size: "sm",
    label: i18n._(
    /*i18n*/
    {
      id: "A1taO8"
    }),
    icon: SearchOutlined,
    variant: "ghost",
    kind: "minimal",
    isRounded: true
  })), /*#__PURE__*/React.createElement(DropdownMenu.List, {
    maxWidth: 240
  }, /*#__PURE__*/React.createElement(DropdownMenu.Item, {
    as: "a",
    onClick: callAllHandlers(closePanel, handleLinkClick(openNetworkLink, env, '/connections/users')),
    href: getNetworkLink(env, '/connections/users')
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "vY0WLo"
  })), /*#__PURE__*/React.createElement(DropdownMenu.Item, {
    as: "a",
    onClick: callAllHandlers(closePanel, handleLinkClick(openNetworkLink, env, '/browse/pros')),
    href: getNetworkLink(env, '/browse/pros')
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "TtyCGv"
  })), /*#__PURE__*/React.createElement(DropdownMenu.Item, {
    as: "a",
    onClick: callAllHandlers(closePanel, handleLinkClick(openSamplesLink, env, '/browse')),
    href: getSamplesLink(env, '/browse')
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "LbxwSW"
  })), /*#__PURE__*/React.createElement(DropdownMenu.Item, {
    as: "a",
    onClick: callAllHandlers(closePanel, handleLinkClick(openEducationLink, env, '/courses')),
    href: getEducationLink(env, '/courses')
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "U9oqBe"
  }))));
};

export { NavBarSearch };
